import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSolarPanel, faCheckCircle, faLeaf, faArrowRight, faHome, faIndustry, faBuilding, faCheck, faAward, faSun, faMoneyBillWave, faCog, faBolt, faShieldAlt, faCalendarAlt, faClock, faFileAlt, faUserTie, faCertificate, faUsers, faHeadset, faUserCheck, faRupeeSign, faPercent, faHandHoldingUsd, faLightbulb, } from '@fortawesome/free-solid-svg-icons';
import SEO from './SEO';

const SolarPower = () => {
  return (
    <div className="services">
  <SEO
    title="Solar Power Solutions | CoreNova Renewable Energy"
    description="Residential, commercial, and industrial solar power systems: design, installation, and maintenance."
    canonical="https://corenovarenewable.com/services/solar"
    keywords="solar power, solar panels, PV, grid-tied, off-grid, installation"
  />

  <section className="relative bg-gradient-to-r from-primary-green to-secondary-blue text-white py-20 lg:py-32 text-center overflow-hidden">
    <div className="absolute inset-0">
      <img src="/images/service hero.png" alt="Solar Services" className="w-full h-full object-cover opacity-60" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-green/40 to-secondary-blue/40"></div>
    </div>
    <div className="container relative z-10">
      <h1 className="text-4xl md:text-6xl font-bold">Solar Power Solutions</h1>
      <p className="text-xl md:text-2xl opacity-90">End-to-end photovoltaic systems for every scale</p>
    </div>
  </section>

  {/* Solar Energy Introduction Section */}
  <section className="section bg-gray-50">
  <div className="container max-w-6xl">
    <div className="text-center mb-16">
      <div className="w-20 h-20 bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl flex items-center justify-center mb-6 mx-auto">
        <FontAwesomeIcon icon={faSun} className="text-3xl text-white" />
      </div>
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
        Harness the Power of Solar Energy
      </h2>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto">
        Transforming sunlight into sustainable energy solutions for homes, businesses, and industries
      </p>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
      <div className="space-y-6">
        <div className="flex items-start gap-4">
          <div className="w-6 h-6 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <FontAwesomeIcon icon={faCheck} className="text-white text-xs" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-dark mb-2">Meeting Today's Energy Needs</h3>
            <p className="text-gray-700">
              Solar energy is becoming one of the most trusted ways to meet today's energy needs. With
              rising electricity costs and a growing need for clean energy, more people are switching to solar
              power solutions.
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="w-6 h-6 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <FontAwesomeIcon icon={faCheck} className="text-white text-xs" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-dark mb-2">Energy Independence</h3>
            <p className="text-gray-700">
              Solar systems allow homes, businesses, and industries to generate their own
              electricity using rooftop space, reducing dependence on traditional power grids and
              contributing to a sustainable future.
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="w-6 h-6 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <FontAwesomeIcon icon={faCheck} className="text-white text-xs" />
          </div>
          <div>
  <h3 className="text-lg font-semibold text-dark mb-2">Complete Solar Solutions</h3>
  <p className="text-gray-700">
    At Corenova Renewable, we specialize in offering complete{" "}
    <a href="/services" className="font-bold text-green-700 hover:underline">
      Renewable Energy Services
    </a>
    . From consultation and design to installation and after-sales support, our goal is to deliver
    long-lasting, efficient, and affordable solar energy systems.
  </p>
</div>

        </div>

      
      </div>
      
      <div className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="/images/solar installation.png" 
            alt="Solar panel installation on rooftop" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
        {/* <div className="absolute -bottom-4 -right-4 bg-white shadow-lg rounded-lg p-4 border border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-primary-green/10 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faAward} className="text-primary-green" />
            </div>
            <div>
              <div className="font-semibold text-dark">Certified Excellence</div>
              <div className="text-sm text-gray-600">Quality guaranteed</div>
            </div>
          </div>
        </div> */}
      </div>
    </div>

    {/* <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
      <div className="grid md:grid-cols-3 gap-6">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-green/10 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faHome} className="text-2xl text-primary-green" />
          </div>
          <h4 className="font-semibold text-dark mb-2">Residential</h4>
          <p className="text-sm text-gray-600">Home solar systems for energy independence</p>
        </div>
        <div className="text-center">
          <div className="w-16 h-16 bg-secondary-blue/10 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faIndustry} className="text-2xl text-secondary-blue" />
          </div>
          <h4 className="font-semibold text-dark mb-2">Commercial</h4>
          <p className="text-sm text-gray-600">Business solutions for cost savings</p>
        </div>
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-green/10 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faBuilding} className="text-2xl text-primary-green" />
          </div>
          <h4 className="font-semibold text-dark mb-2">Industrial</h4>
          <p className="text-sm text-gray-600">Large-scale systems for industries</p>
        </div>
      </div>
    </div> */}
  </div>
</section>
<section className="section bg-white">
  <div className="container max-w-6xl">
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
        Why Rooftop Solar Power is the Future?
      </h2>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto">
        Harness the power of the sun right from your rooftop for sustainable energy and significant savings
      </p>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
      <div>
        <div className="bg-gradient-to-r from-primary-green/10 to-secondary-blue/10 rounded-2xl p-8 mb-8">
          <h3 className="text-2xl font-bold text-dark mb-4">Smart Energy Independence</h3>
          <p className="text-gray-700 leading-relaxed">
            A rooftop solar system is one of the smartest ways to lower energy bills and generate
            electricity right from your home or office roof. Instead of depending only on grid supply, you can
            power your home or workplace using sunlight.
          </p>
        </div>
        
        <div className="space-y-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <FontAwesomeIcon icon={faSun} className="text-white text-lg" />
            </div>
            <div>
              <h4 className="text-lg font-semibold text-dark mb-2">Free Energy Source</h4>
              <p className="text-gray-600">Sunlight is abundant and completely free to harness</p>
            </div>
          </div>
          
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <FontAwesomeIcon icon={faBolt} className="text-white text-lg" />
            </div>
            <div>
              <h4 className="text-lg font-semibold text-dark mb-2">Instant Power Generation</h4>
              <p className="text-gray-600">Start generating electricity immediately after installation</p>
            </div>
          </div>
          
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <FontAwesomeIcon icon={faShieldAlt} className="text-white text-lg" />
            </div>
            <div>
              <h4 className="text-lg font-semibold text-dark mb-2">Grid Independence</h4>
              <p className="text-gray-600">Reduce dependency on unstable grid power</p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="/images/rooftop solar.png" 
            alt="Rooftop solar panel installation" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
        {/* <div className="absolute -bottom-4 -left-4 bg-white shadow-lg rounded-lg p-4 border border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-primary-green/10 rounded-full flex items-center justify-center">
              <FontAwesomeIcon icon={faTrendingUp
                
              } className="text-primary-green" />
            </div>
            <div>
              <div className="font-semibold text-dark">Future-Proof</div>
              <div className="text-sm text-gray-600">Investment for decades</div>
            </div>
          </div>
        </div> */}
      </div>
    </div>

    {/* Three Strong Reasons */}
    <div className="bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl p-8 lg:p-12 text-white">
      <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center">
        3 Strong Reasons Why Corenova Rooftop Solar Power is So Popular
      </h3>
      
      <div className="grid md:grid-cols-3 gap-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faMoneyBillWave} className="text-2xl" />
          </div>
          <h4 className="text-xl font-bold mb-3">Reduces Electricity Bills</h4>
          <p className="opacity-90">Save up to 80% on your monthly electricity expenses</p>
          <div className="mt-4 bg-white/20 rounded-lg p-2 inline-block">
            <span className="font-bold text-2xl">80%</span>
            <span className="text-sm"> Savings</span>
          </div>
        </div>
        
        <div className="text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faLeaf} className="text-2xl" />
          </div>
          <h4 className="text-xl font-bold mb-3">Environment Friendly</h4>
          <p className="opacity-90">Clean, renewable energy with zero carbon emissions</p>
          <div className="mt-4 bg-white/20 rounded-lg p-2 inline-block">
            <span className="font-bold text-2xl">0</span>
            <span className="text-sm"> Emissions</span>
          </div>
        </div>
        
        <div className="text-center">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faCog} className="text-2xl" />
          </div>
          <h4 className="text-xl font-bold mb-3">Low Maintenance</h4>
          <p className="opacity-90">Simple upkeep with a long 20–25 years lifespan</p>
          <div className="mt-4 bg-white/20 rounded-lg p-2 inline-block">
            <span className="font-bold text-2xl">25+</span>
            <span className="text-sm"> Years</span>
          </div>
        </div>
      </div>
      
      <div className="text-center mt-8">
        {/* <Link 
          to="/contact" 
          className="btn bg-white text-primary-green hover:bg-gray-100 px-8 py-3 font-semibold inline-flex items-center gap-2"
        >
          Get Free Consultation
          <FontAwesomeIcon icon={faArrowRight} />
        </Link> */}
      </div>
    </div>

    {/* Additional Benefits */}
    <div className="grid md:grid-cols-2 gap-8 mt-16">
      <div className="bg-gray-50 rounded-2xl p-6">
        <h4 className="text-xl font-bold text-dark mb-4">Government Incentives</h4>
        <p className="text-gray-600 mb-4">
          Take advantage of various subsidies and tax benefits offered for solar installations
        </p>
        <ul className="space-y-2">
          <li className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green" />
            <span>Subsidy programs available</span>
          </li>
          <li className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green" />
            <span>Tax benefits and deductions</span>
          </li>
          <li className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green" />
            <span>Net metering benefits</span>
          </li>
        </ul>
      </div>
      
      <div className="bg-gray-50 rounded-2xl p-6">
        <h4 className="text-xl font-bold text-dark mb-4">Increased Property Value</h4>
        <p className="text-gray-600 mb-4">
          Solar installations can significantly increase your property's market value
        </p>
        <ul className="space-y-2">
          <li className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green" />
            <span>Higher resale value</span>
          </li>
          <li className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green" />
            <span>Attractive to eco-conscious buyers</span>
          </li>
          <li className="flex items-center gap-2">
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green" />
            <span>Long-term investment protection</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section className="section bg-gray-50">
  <div className="container max-w-6xl">
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
        How Solar Panel Installation Works?
      </h2>
      <p className="text-xl text-gray-600 max-w-3xl mx-auto">
        A streamlined process designed for maximum efficiency and optimal results
      </p>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
      <div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 mb-8">
          <p className="text-gray-700 leading-relaxed">
            <a href="/services" >solar panel installation in Odisha</a>S is simple, but it should be planned properly to get the best 
            results. Our expert team ensures a seamless process from assessment to activation.
          </p>
        </div>
        
        <div className="space-y-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span className="text-white font-bold">1</span>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-dark mb-2">Site Assessment</h4>
              <p className="text-gray-600">
                Experts check your rooftop, sunlight exposure, and energy needs to determine the optimal setup.
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span className="text-white font-bold">2</span>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-dark mb-2">System Design</h4>
              <p className="text-gray-600">
                Customized as per your daily power consumption and specific requirements.
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span className="text-white font-bold">3</span>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-dark mb-2">Installation & Testing</h4>
              <p className="text-gray-600">
                Panels, inverters, and wiring are set up and connected to the grid by certified technicians.
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
              <span className="text-white font-bold">4</span>
            </div>
            <div>
              <h4 className="text-lg font-semibold text-dark mb-2">Net Metering Setup</h4>
              <p className="text-gray-600">
                Enables you to sell excess power back to the grid, maximizing your savings.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="/images/solar 1.png" 
            alt="Solar panel installation process" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
       
      </div>
    </div>

    {/* Pre-Installation Checklist */}
    <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
      <h3 className="text-2xl font-bold text-dark mb-6 text-center">
        Pre-Installation Checklist
      </h3>
      <p className="text-gray-700 text-center mb-8 max-w-2xl mx-auto">
        Before installation, ensure your rooftop meets these essential requirements for optimal solar performance:
      </p>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="w-8 h-8 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <FontAwesomeIcon icon={faCheck} className="text-white text-sm" />
          </div>
          <div>
            <h4 className="font-semibold text-dark mb-2">Shadow-Free Area</h4>
            <p className="text-gray-600 text-sm">
              Ensure your rooftop has minimal shading from trees, buildings, or other obstructions
            </p>
          </div>
        </div>
        
        <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="w-8 h-8 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <FontAwesomeIcon icon={faCheck} className="text-white text-sm" />
          </div>
          <div>
            <h4 className="font-semibold text-dark mb-2">Structural Strength</h4>
            <p className="text-gray-600 text-sm">
              Your rooftop should be strong enough to support solar panels (typically 15-20 kg per panel)
            </p>
          </div>
        </div>
        
        <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="w-8 h-8 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <FontAwesomeIcon icon={faCheck} className="text-white text-sm" />
          </div>
          <div>
            <h4 className="font-semibold text-dark mb-2">Proper Orientation</h4>
            <p className="text-gray-600 text-sm">
              South-facing roofs typically receive optimal sunlight in Odisha
            </p>
          </div>
        </div>
        
        <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="w-8 h-8 bg-primary-green rounded-full flex items-center justify-center flex-shrink-0 mt-1">
            <FontAwesomeIcon icon={faCheck} className="text-white text-sm" />
          </div>
          <div>
            <h4 className="font-semibold text-dark mb-2">Adequate Space</h4>
            <p className="text-gray-600 text-sm">
              Sufficient rooftop area for the desired system size (approx. 100 sq ft per kW)
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* CTA Section */}
    {/* <div className="text-center mt-12">
      <div className="bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl p-8 text-white">
        <h3 className="text-2xl font-bold mb-4">Ready to Get Started?</h3>
        <p className="mb-6 opacity-90">
          Our experts will conduct a free site assessment and provide a customized solar solution for your home or business.
        </p>
        <Link 
          to="/ontact" 
          className="btn bg-white text-primary-green hover:bg-gray-100 px-8 py-3 font-semibold inline-flex items-center gap-2"
        >
          Schedule Free Assessment
          <FontAwesomeIcon icon={faCalendarAlt} />
        </Link>
      </div>
    </div> */}
  </div>
</section>


<section className="section bg-white">
  <div className="container max-w-6xl">
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
        Best Solar Company in Odisha for Residential Solar Installation
      </h2>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
      <div>
        <div className="bg-white rounded-2xl p-6 mb-8">
          <p className="text-gray-700 leading-relaxed text-lg">
            To get the right system, you need the <a href="/services/solar">best solar company in Odisha</a>. A good company not 
            only installs panels but also provides comprehensive renewable energy services, including 
            design, maintenance, and customer support.
          </p>
        </div>
        
        <div className="bg-gray-50 rounded-2xl p-6">
          <h3 className="text-xl font-bold text-dark mb-6">Qualities to look for:</h3>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green text-lg mt-1 flex-shrink-0" />
              <span className="text-gray-700">Certified equipment with long warranties.</span>
            </li>
            <li className="flex items-start gap-3">
              <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green text-lg mt-1 flex-shrink-0" />
              <span className="text-gray-700">Skilled engineers and installation team.</span>
            </li>
            <li className="flex items-start gap-3">
              <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green text-lg mt-1 flex-shrink-0" />
              <span className="text-gray-700">Full assistance with subsidies and government paperwork.</span>
            </li>
          </ul>
        </div>

        <div className="mt-8 bg-gradient-to-r from-primary-green/10 to-secondary-blue/10 rounded-2xl p-6">
          <p className="text-gray-700 leading-relaxed italic">
            The best solar power solution in Odisha always comes from experienced providers who offer 
            end-to-end service.
          </p>
        </div>
      </div>
      
      <div className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="/images/solar 3.png" 
            alt="Best solar company in Odisha - Corenova Renewable Energy" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
        
      </div>
    </div>

 
    
  </div>
</section>

<section className="section bg-gray-50">
  <div className="container max-w-6xl">
    <div className="text-center mb-16">
      <h2 className="text-3xl md:text-4xl font-bold text-dark mb-4">
        Commercial Solar Installation in Odisha
      </h2>
    </div>

    <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
      <div>
        <div className="bg-white rounded-2xl p-6 mb-8">
          <p className="text-gray-700 leading-relaxed text-lg">
            Today, many offices, factories, hotels, hospitals, and schools are investing in <a href="/srvices/solar">commercial solar 
            installation in Odisha</a>. Large rooftops in commercial spaces allow high-capacity setups, 
            making solar even more cost-effective.
          </p>
        </div>
        
        <div className="bg-white rounded-2xl p-6 border border-gray-200">
          <h3 className="text-xl font-bold text-dark mb-6">Why commercial solar installation in Bhubaneswar is gaining demand:</h3>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green text-lg mt-1 flex-shrink-0" />
              <span className="text-gray-700">Lower monthly energy expenses with faster return on investment (ROI).</span>
            </li>
            <li className="flex items-start gap-3">
              <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green text-lg mt-1 flex-shrink-0" />
              <span className="text-gray-700">Improved corporate image by adopting green practices.</span>
            </li>
            <li className="flex items-start gap-3">
              <FontAwesomeIcon icon={faCheckCircle} className="text-primary-green text-lg mt-1 flex-shrink-0" />
              <span className="text-gray-700">Energy independence, especially during peak power demand.</span>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="relative">
        <div className="relative rounded-2xl overflow-hidden shadow-xl">
          <img 
            src="/images/commercial solar installation.png" 
            alt="Commercial solar installation in Odisha - Corenova Renewable Energy" 
            className="w-full h-96 object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        </div>
    
        
      </div>
    </div>

    {/* Commercial Benefits */}
    <div className="bg-white rounded-2xl p-8 lg:p-12 border border-gray-200">
      <h3 className="text-2xl font-bold text-dark mb-8 text-center">Commercial Solar Benefits</h3>
      
      <div className="grid md:grid-cols-3 gap-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-green rounded-full flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faMoneyBillWave} className="text-2xl text-white" />
          </div>
          <h4 className="text-lg font-bold text-dark mb-3">Cost Savings</h4>
          <p className="text-gray-600">
            Reduce electricity bills by up to 80% with faster ROI on commercial installations
          </p>
        </div>
        
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-green rounded-full flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faLeaf} className="text-2xl text-white" />
          </div>
          <h4 className="text-lg font-bold text-dark mb-3">Green Image</h4>
          <p className="text-gray-600">
            Enhance your brand reputation by demonstrating environmental responsibility
          </p>
        </div>
        
        <div className="text-center">
          <div className="w-16 h-16 bg-primary-green rounded-full flex items-center justify-center mb-4 mx-auto">
            <FontAwesomeIcon icon={faBolt} className="text-2xl text-white" />
          </div>
          <h4 className="text-lg font-bold text-dark mb-3">Energy Security</h4>
          <p className="text-gray-600">
            Ensure uninterrupted power supply during peak demand and grid outages
          </p>
        </div>
      </div>
    </div>

    {/* CTA Section */}
    {/* <div className="text-center mt-12">
      <div className="bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl p-8 text-white">
        <h3 className="text-2xl font-bold mb-4">Ready for Commercial Solar?</h3>
        <p className="mb-6 opacity-90">
          Get a customized solar solution for your business with guaranteed savings and performance
        </p>
        <Link 
          to="/contact" 
          className="btn bg-white text-primary-green hover:bg-gray-100 px-8 py-3 font-semibold inline-flex items-center justify-center gap-2"
        >
          Get Commercial Quote
          <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
    </div> */}
  </div>
</section>

<section className="section bg-white">
  <div className="container max-w-7xl">
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
        Cost of Solar Installation in Odisha
      </h2>
    </div>

    <div className="mb-16">
      <div className="bg-white rounded-2xl p-8 mb-8 border border-gray-200 text-center mx-auto max-w-4xl">
        <p className="text-xl text-gray-700 leading-relaxed">
          The cost of solar installation in Odisha varies depending on system type and capacity. Below 
          are approximate costs:
        </p>
      </div>

      {/* Pricing Table - Wide Version */}
      <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200">
        <h3 className="text-2xl font-bold text-dark mb-8 text-center">Approximate Costs</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-primary-green text-white">
                <th className="p-4 text-left border border-white text-lg">Item Description</th>
                <th className="p-4 text-center border border-white text-lg">Quantity</th>
                <th className="p-4 text-center border border-white text-lg">Rate (₹)</th>
                <th className="p-4 text-center border border-white text-lg">Total Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200 hover:bg-gray-100 transition-colors">
                <td className="p-4 border border-gray-200 font-medium">30W Semi Integrated Light</td>
                <td className="p-4 border border-gray-200 text-center">33</td>
                <td className="p-4 border border-gray-200 text-center">13,426.14</td>
                <td className="p-4 border border-gray-200 text-center font-semibold">4,43,062.62</td>
              </tr>
              <tr className="border-b border-gray-200 hover:bg-gray-100 transition-colors">
                <td className="p-4 border border-gray-200 font-medium">GI Pole</td>
                <td className="p-4 border border-gray-200 text-center">33</td>
                <td className="p-4 border border-gray-200 text-center">10,811.16</td>
                <td className="p-4 border border-gray-200 text-center font-semibold">3,56,768.28</td>
              </tr>
              <tr className="hover:bg-gray-100 transition-colors">
                <td className="p-4 border border-gray-200 font-medium">Himast 60W High Mast Light</td>
                <td className="p-4 border border-gray-200 text-center">1</td>
                <td className="p-4 border border-gray-200 text-center">90,000.00</td>
                <td className="p-4 border border-gray-200 text-center font-semibold">90,000.00</td>
              </tr>
              <tr className="bg-primary-green/10 font-bold">
                <td className="p-4 border border-gray-200 text-right" colSpan="3">Grand Total</td>
                <td className="p-4 border border-gray-200 text-center text-primary-green text-xl">₹8,89,830.90</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    {/* Additional Information - Wide Layout */}
    <div className="bg-gradient-to-r from-primary-green/10 to-secondary-blue/10 rounded-2xl p-10 mb-16">
      <div className="grid md:grid-cols-2 gap-10">
        <div className="text-center">
          <div className="w-20 h-20 bg-primary-green rounded-full flex items-center justify-center mb-6 mx-auto">
            <FontAwesomeIcon icon={faLightbulb} className="text-3xl text-white" />
          </div>
          <h3 className="text-2xl font-bold text-dark mb-4">Complete Lighting Solutions</h3>
          <p className="text-gray-700 text-lg">
            We also provide a range of specialized lighting solutions to complement our solar offerings, 
            ensuring a complete solution for both your energy and illumination needs.
          </p>
        </div>
        <div className="text-center">
          <div className="w-20 h-20 bg-secondary-blue rounded-full flex items-center justify-center mb-6 mx-auto">
            <FontAwesomeIcon icon={faHandHoldingUsd} className="text-3xl text-white" />
          </div>
          <h3 className="text-2xl font-bold text-dark mb-4">Government Support</h3>
          <p className="text-gray-700 text-lg">
            With state and central government support, the effective cost becomes even lower. Commercial projects, which have 
            larger setups, are usually more cost-efficient on a per kW basis.
          </p>
        </div>
      </div>
    </div>

    {/* Cost Efficiency Factors - Wide Layout */}
    <div className="bg-white rounded-2xl p-10 border border-gray-200 mb-16">
      <h3 className="text-3xl font-bold text-dark mb-12 text-center">Factors Affecting Solar Cost</h3>
      
      <div className="grid md:grid-cols-3 gap-10">
        <div className="text-center">
          <div className="w-20 h-20 bg-primary-green rounded-full flex items-center justify-center mb-6 mx-auto">
            <FontAwesomeIcon icon={faBuilding} className="text-3xl text-white" />
          </div>
          <h4 className="text-xl font-bold text-dark mb-4">System Size</h4>
          <p className="text-gray-600 text-lg">
            Larger commercial systems typically have lower cost per kW due to economies of scale
          </p>
        </div>
        
        <div className="text-center">
          <div className="w-20 h-20 bg-primary-green rounded-full flex items-center justify-center mb-6 mx-auto">
            <FontAwesomeIcon icon={faShieldAlt} className="text-3xl text-white" />
          </div>
          <h4 className="text-xl font-bold text-dark mb-4">Quality</h4>
          <p className="text-gray-600 text-lg">
            Premium components may cost more initially but offer better long-term performance
          </p>
        </div>
        
        <div className="text-center">
          <div className="w-20 h-20 bg-primary-green rounded-full flex items-center justify-center mb-6 mx-auto">
            <FontAwesomeIcon icon={faPercent} className="text-3xl text-white" />
          </div>
          <h4 className="text-xl font-bold text-dark mb-4">Subsidies</h4>
          <p className="text-gray-600 text-lg">
            Government subsidies can reduce effective cost by 30-40% for eligible projects
          </p>
        </div>
      </div>
    </div>

    {/* CTA Section - Wide Layout */}
    <div className="text-center">
      <div className="bg-gradient-to-r from-primary-green to-secondary-blue rounded-2xl p-12 text-white">
        <h3 className="text-3xl font-bold mb-6">Get Exact Pricing</h3>
        <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
          Contact us for a detailed quote tailored to your specific requirements and location
        </p>
        <a href 
          ="/contact" 
          className="btn bg-white text-primary-green hover:bg-gray-100 px-10 py-4 text-lg font-semibold inline-flex items-center justify-center gap-3"
        >
          Request Detailed Quote
          <FontAwesomeIcon icon={faArrowRight} className="text-lg" />
        </a>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};

export default SolarPower; 